import { cn } from "@utils/cn.ts";
import DateCell from "./DateCell";

function Calendar({
  activeDate,
  holidayDates,
  dailyConfigs,
  onConfigChange,
}: {
  activeDate: { year: number; month: number };
  holidayDates: string[];
  dailyConfigs?: Record<string, number>;
  onConfigChange?: (date: string, val: number) => void;
}) {
  const firstDay = new Date(activeDate.year, activeDate.month - 1, 1);
  const lastDay = new Date(activeDate.year, activeDate.month, 0);
  const daysInMonth = lastDay.getDate();
  let startDay = firstDay.getDay(); // 한 주 시작 : 일
  startDay = (startDay + 6) % 7; // 한 주 시작 : 월

  const nextMonthDay = new Date(activeDate.year, activeDate.month, 1).getDay();

  const weeks: React.JSX.Element[][] = [];
  let currentWeek: React.JSX.Element[] = [];

  for (let i = 0; i < startDay; i++) {
    const prevDate = new Date(firstDay);
    prevDate.setDate(prevDate.getDate() - (startDay - i));
    const day = prevDate.getDate();
    const weekend = prevDate.getDay() % 7;

    currentWeek.push(
      <td
        className={`!p-[0px] !border-[#D6D6DE] other-month ${weekend === 6 ? "calendar_sat" : weekend === 0 ? "calendar_sun" : ""}`}
        key={`prev-${i}`}
      >
        <div className="calendar-date !text-[#D6D6DE] !font-light">{day}</div>
      </td>
    );
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${activeDate.year}-${String(activeDate.month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const weekend = (day + startDay) % 7;

    const isHol = holidayDates.includes(dateStr);
    currentWeek.push(
      <td key={dateStr} className="!p-0 !border-[#D6D6DE]">
        <DateCell
          day={day}
          dateStr={dateStr}
          holiday={{ weekend: weekend, isHol: isHol }}
          value={dailyConfigs?.[dateStr]}
          onChange={(val) => onConfigChange?.(dateStr, val)}
        />
      </td>
    );

    if (currentWeek.length === 7) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  }

  const remainingCells = 7 - currentWeek.length;

  if (remainingCells > 0) {
    {
      Array.from({ length: remainingCells }, (_, i) => {
        const weekend = (nextMonthDay + i) % 7;
        currentWeek.push(
          <td
            key={`empty-${i + 1}`}
            className={`!p-0 !border-[#D6D6DE] other-month ${weekend === 6 ? "calendar_sat" : weekend === 0 ? "calendar_sun" : ""}`}
          >
            <div className="calendar-date !text-[#D6D6DE] !font-light">
              {i + 1}
            </div>
          </td>
        );
      });
    }
    weeks.push(currentWeek);
  }

  return (
    <table className="w_myWanted__calendar w_myWanted__selectCalendar  w-full!">
      <thead>
        <tr>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sub !text-[15px]"
            )}
          >
            월
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sub !text-[15px]"
            )}
          >
            화
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sub !text-[15px]"
            )}
          >
            수
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sub !text-[15px]"
            )}
          >
            목
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sub !text-[15px]"
            )}
          >
            금
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sat !text-[15px]"
            )}
          >
            토
          </th>
          <th
            className={cn(
              "font-pretendard font-semibold text-text-sun !text-[15px]"
            )}
          >
            일
          </th>
        </tr>
      </thead>
      <tbody className="calendar-body">
        {weeks.map((week, idx) => (
          <tr key={idx}>{week}</tr>
        ))}
      </tbody>
    </table>
  );
}

export default Calendar;
